import * as z from 'zod';
import { closedReasonSchema, CLOSED_REASON_NOTE_MAX_LENGTH, suretyAccountStatusSchema, suretyQuoteStatusSchema } from '../../../enums.mjs';
import { Currency } from '../../currency/currency.mjs';
import { isoDateTimeSchema, agencyId } from '../../opaque.mjs';
import { exposureSchema, nonNegativeCurrencySchema } from '../../utils.mjs';
import { Metadata as Metadata$1 } from './commercial/commercial-surety-account.types.mjs';
import * as commercialSuretyAccount_types from './commercial/commercial-surety-account.types.mjs';
export { commercialSuretyAccount_types as Commercial };
import { Exposure as Exposure$1, Metadata as Metadata$2 } from './contract/contract-surety-account.types.mjs';
import * as contractSuretyAccount_types from './contract/contract-surety-account.types.mjs';
export { contractSuretyAccount_types as Contract };

var Exposure;
(function (Exposure) {
    Exposure.initialize = () => ({
        quotes: 0,
        bonds: 0,
        total: 0,
        contract: Exposure$1.initialize(),
    });
    Exposure.schema = exposureSchema.extend({
        contract: Exposure$1.schema,
    });
})(Exposure || (Exposure = {}));
var BrokerOfRecord;
(function (BrokerOfRecord) {
    BrokerOfRecord.schema = z.object({
        previousAgencyId: agencyId,
        newAgencyId: agencyId,
        effectiveDate: isoDateTimeSchema,
    });
})(BrokerOfRecord || (BrokerOfRecord = {}));
var Metadata;
(function (Metadata) {
    Metadata.schema = z.object({
        causedSuretyLoss: z.boolean().nullish(),
        contract: Metadata$2.schema.nullish(),
        commercial: Metadata$1.schema.nullish(),
        brokerOfRecord: BrokerOfRecord.schema.nullish(),
    });
})(Metadata || (Metadata = {}));
var Config;
(function (Config) {
    const limitsSchema = z.object({
        singleLimit: nonNegativeCurrencySchema.transform(Currency.round),
        aggregateLimit: nonNegativeCurrencySchema.transform(Currency.round),
    });
    const fields = z.object({
        pauseBondIssuance: z.boolean(),
        adminManagedReUnderwriteForNonExpiredUnderwriting: z.boolean(),
        useSyntheticFinancialStatement: z.boolean(),
        bondingLinePublished: z.boolean(),
        bondingLineLimits: limitsSchema.optional(),
    });
    Config.schema = fields.extend({
        bondingLinePublished: fields.shape.bondingLinePublished.default(false),
    });
    Config.changeSchema = fields.partial();
})(Config || (Config = {}));
var FYE;
(function (FYE) {
    FYE.schema = z
        .object({
        month: z.number(),
        day: z.number(),
    })
        .nullable();
})(FYE || (FYE = {}));
var Underwriting;
(function (Underwriting) {
    (function (LetterGrade) {
        LetterGrade["A"] = "A";
        LetterGrade["A_MINUS"] = "A-";
        LetterGrade["B_PLUS"] = "B+";
        LetterGrade["B"] = "B";
        LetterGrade["B_MINUS"] = "B-";
        LetterGrade["F"] = "F";
    })(Underwriting.LetterGrade || (Underwriting.LetterGrade = {}));
})(Underwriting || (Underwriting = {}));
var ContactRelationshipConfig;
(function (ContactRelationshipConfig) {
    let Contract;
    (function (Contract) {
        Contract.schema = z.object({
            includeInUnderwriting: z.boolean(),
            includeInIndemnity: z.boolean(),
        });
    })(Contract = ContactRelationshipConfig.Contract || (ContactRelationshipConfig.Contract = {}));
    ContactRelationshipConfig.schema = z.object({
        contract: Contract.schema,
    });
})(ContactRelationshipConfig || (ContactRelationshipConfig = {}));
var ClosedData;
(function (ClosedData) {
    ClosedData.schema = z.object({
        reason: closedReasonSchema,
        closedAt: isoDateTimeSchema,
        priorStatus: suretyAccountStatusSchema.or(suretyQuoteStatusSchema),
        note: z.string().max(CLOSED_REASON_NOTE_MAX_LENGTH).nullish(),
    });
})(ClosedData || (ClosedData = {}));

export { BrokerOfRecord, ClosedData, Config, ContactRelationshipConfig, Exposure, FYE, Metadata, Underwriting };
